import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../modules/auth/AuthContext';
import { validateLoginForm, hasErrors } from '../../lib/validation';
import { Button } from '../../components/ui/Button';
import styles from './AdminLogin.module.css';

export function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [authError, setAuthError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setErrors((prev) => ({ ...prev, [e.target.name]: '' }));
    setAuthError(null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const errs = validateLoginForm(form);
    if (hasErrors(errs)) { setErrors(errs); return; }
    setLoading(true);
    const result = await login(form);
    setLoading(false);
    if (result.success) {
      navigate('/admin');
    } else {
      setAuthError(result.error ?? 'Login failed');
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <span className={styles.brandName}>HubWire</span>
          <span className={styles.brandSub}>Admin Access</span>
        </div>

        <form onSubmit={handleSubmit} noValidate className={styles.form}>
          <div className={styles.field}>
            <label htmlFor="email" className={styles.label}>Email</label>
            <input
              id="email"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              autoComplete="email"
              className={[styles.input, errors.email ? styles.inputError : ''].join(' ')}
              placeholder="admin@organization.ca"
            />
            {errors.email && <p className={styles.error}>{errors.email}</p>}
          </div>

          <div className={styles.field}>
            <label htmlFor="password" className={styles.label}>Password</label>
            <input
              id="password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              autoComplete="current-password"
              className={[styles.input, errors.password ? styles.inputError : ''].join(' ')}
            />
            {errors.password && <p className={styles.error}>{errors.password}</p>}
          </div>

          {authError && (
            <div className={styles.authError}>{authError}</div>
          )}

          <Button type="submit" size="lg" loading={loading} style={{ width: '100%' }}>
            Sign In
          </Button>
        </form>

        <p className={styles.hint}>
          Demo: <code>admin@kindersleycurling.ca</code> / <code>hubwire2026</code>
        </p>
      </div>
    </div>
  );
}
